import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_gc-tech-setup/artifacts/2ykd7f8a_FB_IMG_1759261601436.jpg" 
                alt="GC STORE - GAMERS CHOICE" 
                className="h-16 w-auto object-contain"
              />
            </Link>
            <p className="text-gray-500 text-sm">
              Votre destination gaming à Dar El Beïda. Équipements, composants et accessoires gaming de qualité.
            </p>
            <p className="text-gray-500 text-sm mt-2">
              بيع و تصليح - Consoles et Accessoires de jeux
            </p>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-gray-900 font-bold mb-4">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-2 text-gray-500 text-sm">
                <MapPin className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" />
                <span>N°13 Lotissement Mohamed Essadik Benyahia, Dar El Beïda, Alger</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-500 text-sm">
                <Phone className="w-5 h-5 text-cyan-400" />
                <a href="tel:+213552108488" className="hover:text-gray-900 transition">
                  +213 552 10 84 88
                </a>
              </div>
              <div className="flex items-center space-x-2 text-gray-500 text-sm">
                <Facebook className="w-5 h-5 text-cyan-400" />
                <a href="https://www.facebook.com/share/1FQC6R4eFw/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-900 transition">
                  Facebook GC Store
                </a>
              </div>
              <div className="flex items-center space-x-2 text-gray-500 text-sm">
                <svg className="w-5 h-5 text-cyan-400" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
                <a href="https://www.instagram.com/gcstoredz?igsh=aDNkdGltdW1pZmU=" target="_blank" rel="noopener noreferrer" className="hover:text-gray-900 transition">
                  @gcstoredz
                </a>
              </div>
            </div>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-gray-900 font-bold mb-4">Liens Rapides</h3>
            <ul className="space-y-2 text-gray-500 text-sm">
              <li><a href="/" className="hover:text-gray-900 transition">Accueil</a></li>
              <li><a href="/products" className="hover:text-gray-900 transition">Produits</a></li>
              <li><a href="/contact" className="hover:text-gray-900 transition">Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-8 pt-8 text-center text-gray-500 text-sm">
          <p>&copy; {new Date().getFullYear()} GC STORE. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;